// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
// import 'vant/lib/icon/local.css';//引用字体cs
import {post,fetch} from './utils/https/https.js'
import api from './utils/https/api.js'
import { Popover } from 'vant';
import touch from 'vue-directive-touch';
Vue.use(touch);


Vue.prototype.$post=post;
Vue.prototype.$get=fetch;
Vue.prototype.$api=api;
// Vue.prototype.$router=router;
// import http from './utils/fatch.js'
// Vue.prototype.$axios=axios
// Vue.prototype.$http=http
Vue.use(Vant)
Vue.use(Popover);

Vue.config.silent = true

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js